export default [
  {
    path: 'letter',
    name: 'letter',
    component: () => import('@/views/pages/letter/Letter.vue'),
    meta: {
      pageTitle: 'Letters',
      breadcrumb: [
        {
          text: 'Letters',
          active: true,
        },
      ],
      resource: 'Letter',
    },
  },
  {
    path: 'letter/:id',
    name: 'letter-view',
    component: () => import('@/views/pages/letter/View.vue'),
    meta: {
      pageTitle: 'Letters',
      breadcrumb: [
        {
          to: { name: 'letter' },
          text: 'Letters',
          active: false,
        },
        {
          text: 'Letter',
          active: true,
        },
      ],
      resource: 'Letter',
    },
  },
  {
    path: 'letter/:id/history',
    name: 'letter-history',
    component: () => import('@/views/pages/letter/History.vue'),
    meta: {
      pageTitle: 'Letters',
      breadcrumb: [
        {
          to: { name: 'letter' },
          text: 'Letters',
          active: false,
        },
        {
          text: 'History',
          active: true,
        },
      ],
      resource: 'Letter',
    },
  },
]
